module.exports = "<div class=\"footer-sign text-center margin-top-sm margin-bottom-lg\">\n  Passionately built with <i class=\"fa fa-heart text-danger\"></i> by <strong>Fizzy Team</strong>\n  <br/>{{version}}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = ./src/app/components/footer/footer.component.html
// module chunks = main